import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = Yup.object().shape({
  assetCategory: Yup.string().nullable(),
  assetName: Yup.string().nullable().required('Name is required'),
  id: Yup.string().nullable(),
  assetTypeId: Yup.string().nullable().required('Type is required'),
  // location: Yup.string().nullable(),
  notes: Yup.string().nullable(),
  type: Yup.string().nullable(),
  locationId: Yup.string()
    .nullable()
    .when('locationType', {
      is: 'customer-location',
      then: Yup.string().nullable().required('Location is required'),
    }),
})

export const formOptions = {
  defaultValues: {
    assetName: '',
    notes: '',
    assetTypeId: '',
    customer: null,
    locationType: 'yard-location',
    locationId: '',
  },
  resolver: yupResolver(validationSchema),
}

export default validationSchema
